import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';
import EmailIcon from '@material-ui/icons/Email';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import SendIcon from '@material-ui/icons/Send';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ContactsIcon from '@material-ui/icons/Contacts';

import classes from './navigation.module.css';

import ToolsMenu from './Components/ToolsMenu';
import AppNavButton from './Components/AppNavButton';
import ConfirmModal from '../Components/ConfirmModal/ConfirmModal';
import Actions from '../../Features/ContractManagement/Generic/Appointments/Components/Updater/store/updater.actions';
import useUpdatedUI from 'Common/Utils/Hooks/useUpdatedUI';
import { clearAllTeamsUpdates } from '../../Redux/Actions/Contract.Teams.Actions';
import { clearAllFeesUpdates } from '../../Redux/Actions/Contract.Fees.Actions';
import { clearAllScriptDatesUpdates } from '../../Redux/Actions/Script.Dates.Actions';

const AppNavigation = () => {
	const [anchorEl, setAnchorEl] = useState(null);
	const isMenuOpen = Boolean(anchorEl);
	const dispatch = useDispatch();
	const updatedUI = useUpdatedUI();
	let isUpdatedData = updatedUI ? true : false;
	const [isUnsavedData, setIsUnsavedData] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [isClose, setIsClose] = useState(false);
	const history = useHistory();

	const handleProfileMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleActionsKeypress = (e) => {
		if (e.key === "Enter") {
			handleProfileMenuOpen(e);
			handleUnsavedData();
		}
	}

	const handleDashboardClick = event => {
		if (isUpdatedData && !isClose) {
			event.preventDefault();
			isUpdatedData = false;
			setShowModal(true);
			setIsClose(true);
		} else {
			setIsClose(false);
		}
	};

	const handleUnsavedData = () => {
		if (isUpdatedData && !isUnsavedData) {
			isUpdatedData = false;
			setIsUnsavedData(true);
			setShowModal(true);
			return true;
		} else {
			setIsUnsavedData(false);
			return false;
		}
	};

	const resetState = () => {
		setIsUnsavedData(false);
		setShowModal(false);
		resetUI();
	};

	const handleOk = () => {
		setShowModal(false);
		dispatch({ type: Actions.CLOSE_MODAL });
	};

	const appointeesUrl = process.env.REACT_APP_APPOINTEES_URL;
	const logo = process.env.REACT_APP_IMAGES_STORE + "logo-primary-colour-inverted-large.png";

	const resetUI = () => {
		switch (updatedUI) {
			case 'teams':
				dispatch(clearAllTeamsUpdates());
				break;
			case 'fees':
				dispatch(clearAllFeesUpdates());
				break;
			case 'scriptdates':
				dispatch(clearAllScriptDatesUpdates());
				break;
			// no default
		}
	};

	return (
		<>
			<AppBar position="static">
				<Toolbar>
                    <a href={appointeesUrl} title="Qualifications Scotland Appointees Portal">
                        <img src={logo} className={classes['qs-logo']} alt="Qualifications Scotland Logo Appointees Portal Link" />
					</a>
                    <Typography className={classes['title']} variant="h1" noWrap>
						Contract Management
					</Typography>

					<div className={classes.grow} />
					<nav className={classes['section-desktop']}>
						<Link
							tabIndex="-1"
							to={'/'}
							onClick={e => {
								setIsUnsavedData(true);
								handleDashboardClick(e);
							}}
						>
                            <span tabIndex="0" role="link" aria-label="Dashboard Menu Item" className="home-menu-link"
								onKeyPress={e => {
									setIsUnsavedData(true);
									handleDashboardClick(e);
									history.push('/');
								}}							
							>
                                <span className="home-menu-icon" role="img" title="Dashboard"><DashboardIcon /></span>
                            </span>
						</Link>
						<AppNavButton
							path="/contractmanagement"
							text="Contract Management"
							showGroupingMenu={true}
							icon={<ContactsIcon />}
							variant="header"
							isUpdatedData={isUpdatedData}
							handleUnsavedData={handleUnsavedData}
							resetState={resetState}
						/>
						<AppNavButton
							path="/appointeemanagement"
							text="Appointee Management"
							showGroupingMenu={true}
							icon={<AssignmentIndIcon />}
							variant="header"
							isUpdatedData={isUpdatedData}
							handleUnsavedData={handleUnsavedData}
							resetState={resetState}
						/>
						<AppNavButton
							path="/contractrelease"
							text="Release Management"
							showGroupingMenu={true}
							icon={<SendIcon />}
							variant="header"
							isUpdatedData={isUpdatedData}
							handleUnsavedData={handleUnsavedData}
							resetState={resetState}
						/>
						<AppNavButton
							path="/uploadfiles"
							text="Upload Files"
							showGroupingMenu={true}
							icon={<CloudUploadIcon />}
							variant="header"
							isUpdatedData={isUpdatedData}
							handleUnsavedData={handleUnsavedData}
							resetState={resetState}
						/>
						<AppNavButton
							path="/utilities"
							text="Utilities"
							showGroupingMenu={false}
							icon={<EmailIcon />}
							variant="header"
							isUpdatedData={isUpdatedData}
							handleUnsavedData={handleUnsavedData}
							resetState={resetState}
						/>
						<Link tabIndex="-1" to="/">
                            <span tabIndex="0" role="link" aria-label="Actions and Log Out" className="home-menu-link"
								onKeyPress={handleActionsKeypress}															
								onClick={e => {
                                    handleProfileMenuOpen(e);
                                    handleUnsavedData();
                                }}>
                                <span className="home-menu-icon" role="img" title="Actions and Log Out"><SettingsIcon /></span>
                            </span>
						</Link>
					</nav>
				</Toolbar>
			</AppBar>
			<ConfirmModal
				isOpen={showModal}
				showWithdraw={false}
				showProceed={true}
				proceedButton={'Ok'}
				onProceed={handleOk}
				heading={'Save Changes'}
				message={'If you navigate, any unsaved changes will be lost.'}
			/>
			<ToolsMenu anchorEl={anchorEl} isMenuOpen={isMenuOpen} handleMenuClose={handleMenuClose} />
		</>
	);
};

export default AppNavigation;
